module.exports = __webpack_public_path__ + "static/media/gmail-icon.8e79ab39.svg";